/**
 * BST Product Category Tabs — tab panels + synced featured products.
 */
(function () {
  'use strict';

  const ACTIVE_CLASS = 'is-active';
  const SELECTORS = {
    root: '[data-bst-product-category-tabs]',
    tab: '[data-bst-product-category-tab]',
    panel: '[data-bst-product-category-panel]',
    featured: '[data-bst-product-category-featured]',
  };

  function setPanelHidden(panel, hidden) {
    panel.classList.toggle(ACTIVE_CLASS, !hidden);
    panel.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    panel.toggleAttribute('hidden', hidden);
  }

  function activateTab(root, tabKey) {
    const tabs = [...root.querySelectorAll(SELECTORS.tab)];
    const panels = [...root.querySelectorAll(SELECTORS.panel)];
    const featuredPanels = [...root.querySelectorAll(SELECTORS.featured)];

    tabs.forEach((tab) => {
      const isActive = tab.dataset.bstProductCategoryTab === tabKey;
      tab.classList.toggle(ACTIVE_CLASS, isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.bstProductCategoryPanel === tabKey;
      setPanelHidden(panel, !isActive);
    });

    featuredPanels.forEach((featured) => {
      const isActive = featured.dataset.bstProductCategoryFeatured === tabKey;
      setPanelHidden(featured, !isActive);
    });

    root.dispatchEvent(
      new CustomEvent('bst:product-category-tab-change', {
        bubbles: true,
        detail: { tabKey },
      })
    );
  }

  function bindTabs(root) {
    const tabs = [...root.querySelectorAll(SELECTORS.tab)];
    const panels = [...root.querySelectorAll(SELECTORS.panel)];

    if (!tabs.length || !panels.length) return;

    const panelKeys = new Set(panels.map((panel) => panel.dataset.bstProductCategoryPanel));
    const validTabs = tabs.filter((tab) => panelKeys.has(tab.dataset.bstProductCategoryTab));

    if (!validTabs.length) return;

    const initial =
      root.querySelector(`${SELECTORS.tab}.${ACTIVE_CLASS}`)?.dataset.bstProductCategoryTab ||
      validTabs[0].dataset.bstProductCategoryTab;

    activateTab(root, initial);

    validTabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(root, tab.dataset.bstProductCategoryTab));

      tab.addEventListener('keydown', (event) => {
        const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
        if (!keys.includes(event.key)) return;

        event.preventDefault();
        const index = validTabs.indexOf(tab);
        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % validTabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + validTabs.length) % validTabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = validTabs.length - 1;

        validTabs[nextIndex]?.focus();
        activateTab(root, validTabs[nextIndex].dataset.bstProductCategoryTab);
      });
    });
  }

  function initRoot(root) {
    if (root._bstProductCategoryTabsInit) return;
    root._bstProductCategoryTabsInit = true;
    bindTabs(root);
  }

  function init() {
    document.querySelectorAll(SELECTORS.root).forEach(initRoot);
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(SELECTORS.root).forEach(initRoot);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
